const messages = {
  pl: {
    city: "Miasto",
    anyCity: "Dowolne miasto",
    specialist: "Specjalista",
    anySpecialist: "Dowolny specjalista",
    selectedSpecialist: "Wybrany specjalista",
    guidance: "Wybierz miasto lub specjalistę. Możesz też użyć obu filtrów.",
    required: "Wybierz miasto lub specjalistę",
    noSpecialists: "Brak specjalistów do wyboru",
    noSpecialistsInCity: "Brak specjalistów w wybranym mieście",
    noCities: "Brak miast do wyboru dla tego specjalisty",
    catalogError: "Nie udało się pobrać listy specjalistów",
    servicesError: "Nie udało się pobrać usług specjalisty",
    noServices: "Ten specjalista nie ma usług dostępnych do rezerwacji online",
    retry: "Spróbuj ponownie",
  },
  en: {
    city: "City",
    anyCity: "Any city",
    specialist: "Specialist",
    anySpecialist: "Any specialist",
    selectedSpecialist: "Selected specialist",
    guidance: "Choose a city or a specialist. You can use both filters.",
    required: "Choose a city or a specialist",
    noSpecialists: "No specialists to choose from",
    noSpecialistsInCity: "No specialists in the selected city",
    noCities: "No cities to choose from for this specialist",
    catalogError: "Unable to load specialists",
    servicesError: "Unable to load the specialist’s services",
    noServices: "This specialist has no services available for online booking",
    retry: "Retry",
  },
};
export const getBookingFilterMessages = (locale: string) => messages[locale === "pl" ? "pl" : "en"];
